import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

// ── Ícones SVG inline (sem dependências) ──────────────────
const Svg = ({ children, size=20, color='currentColor', stroke=1.8 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);
const IcoShield   = ({s,c}) => <Svg size={s} color={c}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></Svg>;
const IcoLock     = ({s,c}) => <Svg size={s} color={c}><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></Svg>;
const IcoTruck    = ({s,c}) => <Svg size={s} color={c}><path d="M5 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3"/><rect x="9" y="11" width="14" height="10" rx="1"/><circle cx="12" cy="21" r="1"/><circle cx="20" cy="21" r="1"/></Svg>;
const IcoStar     = ({s,c}) => <Svg size={s} color={c}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></Svg>;
const IcoCheck    = ({s,c}) => <Svg size={s} color={c}><polyline points="20 6 9 17 4 12"/></Svg>;
const IcoUsers    = ({s,c}) => <Svg size={s} color={c}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></Svg>;
const IcoPackage  = ({s,c}) => <Svg size={s} color={c}><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></Svg>;
const IcoZap      = ({s,c}) => <Svg size={s} color={c}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></Svg>;
const IcoMapPin   = ({s,c}) => <Svg size={s} color={c}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></Svg>;
const IcoMail     = ({s,c}) => <Svg size={s} color={c}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></Svg>;
const IcoPhone    = ({s,c}) => <Svg size={s} color={c}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.55 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.49a16 16 0 0 0 6.29 6.29l.87-.87a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></Svg>;
const IcoGlobe    = ({s,c}) => <Svg size={s} color={c}><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></Svg>;
const IcoPercent  = ({s,c}) => <Svg size={s} color={c}><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></Svg>;
const IcoClock    = ({s,c}) => <Svg size={s} color={c}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></Svg>;
const IcoTag      = ({s,c}) => <Svg size={s} color={c}><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></Svg>;
const IcoArrow    = ({s,c}) => <Svg size={s} color={c}><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></Svg>;
const IcoMenu     = ({s,c}) => <Svg size={s} color={c}><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></Svg>;

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default function LandingPage() {
  const navigate = useNavigate();
  const [scrolled,   setScrolled]   = useState(false);
  const [menuOpen,   setMenuOpen]   = useState(false);
  const [stats,      setStats]      = useState(null);
  const [contactOk,  setContactOk]  = useState(false);
  const [contactNome,setContactNome]= useState('');
  const [contactEmail,setContactEmail]=useState('');
  const [contactMsg, setContactMsg] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    fetch(`${BASE}/stats`)
      .then(r => r.json())
      .then(d => { if (d.sucesso) setStats(d.stats); })
      .catch(() => {});
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const [contactLoading, setContactLoading] = useState(false);
  const [contactErro,    setContactErro]    = useState('');

  const enviarContacto = async (e) => {
    e.preventDefault();
    if (!contactNome || !contactEmail || !contactMsg) return;
    setContactLoading(true); setContactErro('');
    try {
      const r = await fetch(`${BASE}/contactos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nome: contactNome, email: contactEmail, mensagem: contactMsg }),
      });
      const d = await r.json();
      if (d.sucesso) {
        setContactOk(true);
        setContactNome(''); setContactEmail(''); setContactMsg('');
        setTimeout(() => setContactOk(false), 5000);
      } else {
        setContactErro(d.mensagem || 'Erro ao enviar mensagem');
      }
    } catch {
      setContactErro('Erro de ligação. Tenta novamente.');
    } finally {
      setContactLoading(false);
    }
  };

  const scrollTo = (id) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="lp-root">

      {/* ── NAV ── */}
      <nav className={`lp-nav${scrolled ? ' lp-nav-scrolled' : ''}`}>
        <div className="lp-nav-logo" onClick={() => scrollTo('hero')} style={{cursor:'pointer'}}>
          <div className="lp-logo-k">K</div>
          <span className="lp-logo-name">KiAluga</span>
        </div>
        <div className={`lp-nav-links${menuOpen ? ' lp-nav-open' : ''}`}>
          <span onClick={() => scrollTo('como')}>Como funciona</span>
          <span onClick={() => scrollTo('features')}>Funcionalidades</span>
          <span onClick={() => scrollTo('seguranca')}>Segurança</span>
          <span onClick={() => scrollTo('contacto')}>Contacto</span>
        </div>
        <div className="lp-nav-cta">
          <button className="btn btn-outline lp-btn-ghost" onClick={() => navigate('/login')}>Entrar</button>
          <button className="btn btn-primary" onClick={() => navigate('/login')}>Começar grátis</button>
        </div>
        <button className="lp-hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <IcoMenu s={20} c="rgba(255,255,255,0.8)"/>
        </button>
      </nav>

      {/* ── HERO ── */}
      <section className="lp-hero" id="hero">
        <div className="lp-hero-glow"></div>
        <div className="lp-hero-content">
          <div className="lp-hero-badge">
            <span className="lp-badge-dot"></span>
            MVP em desenvolvimento · Angola
          </div>
          <h1 className="lp-hero-title">
            <span className="lp-accent">Aluga tudo.</span>
            <span className="lp-line2">Paga com segurança.</span>
            <span className="lp-line2">Sem risco.</span>
          </h1>
          <p className="lp-hero-sub">
            A KiAluga é a plataforma angolana de aluguer e venda com pagamento protegido por escrow.
            Monetiza o que tens parado. Acede ao que precisas sem comprar.
          </p>
          <div className="lp-hero-actions">
            <button className="btn btn-primary btn-lg" onClick={() => navigate('/login')}
              style={{display:'flex',alignItems:'center',gap:'8px'}}>
              Explorar produtos <IcoArrow s={16} c="#fff"/>
            </button>
            <button className="lp-btn-white btn" onClick={() => scrollTo('como')}>
              Ver como funciona
            </button>
          </div>
          <div className="lp-hero-stats">
            {[
              { val: stats ? `+${stats.produtos}` : '+0', label:'Produtos disponíveis' },
              { val:'100%', label:'Pagamentos protegidos' },
              { val: stats ? `${stats.utilizadores}` : '0', label:'Utilizadores registados' },
              { val: stats ? `${stats.reservasConcluidas}` : '0', label:'Reservas concluídas' },
            ].map((s, i) => (
              <React.Fragment key={i}>
                {i > 0 && <div className="lp-stat-div"></div>}
                <div className="lp-stat">
                  <div className="lp-stat-val"><span className="lp-accent">{s.val}</span></div>
                  <div className="lp-stat-label">{s.label}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* ── LOGOS ── */}
      <div className="lp-logos-strip">
        <span className="lp-logos-label">Parcerias e integrações</span>
        <div className="lp-logos-row">
          {['Yango','Heetch','Multicaixa','Mecofarma','Fermat'].map(p=>(
            <span key={p} className="lp-logo-partner">{p}</span>
          ))}
        </div>
      </div>

      {/* ── PROBLEMA ── */}
      <section className="lp-section" id="problema" style={{background:'#060E1C'}}>
        <div style={{textAlign:'center',maxWidth:'600px',margin:'0 auto 100px'}}>
          <div className="lp-section-label">
            <IcoZap s={40} c="#F97316"/> O problema
          </div>
          <h2 className="lp-section-title">O mercado de aluguer em Angola é um caos</h2>
          <p style={{fontSize:'16px',color:'rgba(255,255,255,0.6)',lineHeight:'1.65'}}>
            Comprar é caro para uso pontual. O aluguer informal é cheio de conflitos, sem garantias e sem confiança.
          </p>
        </div>
        <div className="lp-problem-grid">
          {[
            { ico:<IcoTag s={20} c="#F97316"/>, bg:'rgba(249,115,22,0.12)', border:'rgba(249,115,22,0.2)', title:'Comprar é caro para uso pontual', desc:'Pagar 18.000 Kz por uma câmara para um evento de fim de semana não faz sentido. Os bens ficam parados depois.' },
            { ico:<IcoShield s={20} c="#EF4444"/>, bg:'rgba(239,68,68,0.10)', border:'rgba(239,68,68,0.2)', title:'Aluguer informal é inseguro', desc:'Sem contrato, sem garantia, sem protecção. Danos, não devoluções e conflitos são frequentes e sem solução.' },
            { ico:<IcoUsers s={20} c="#8B5CF6"/>, bg:'rgba(139,92,246,0.10)', border:'rgba(139,92,246,0.2)', title:'Falta de confiança entre desconhecidos', desc:'Como confiar num desconhecido online? Sem verificação de identidade, o risco é enorme para ambas as partes.' },
            { ico:<IcoPackage s={20} c="#F59E0B"/>, bg:'rgba(245,158,11,0.10)', border:'rgba(245,158,11,0.2)', title:'Bens parados e improdutivos', desc:'Vestidos usados uma vez, equipamentos sem uso. Activos que podiam gerar rendimento em Kz todos os meses.' },
          ].map((c,i)=>(
            <div key={i} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'16px',padding:'24px',transition:'all 0.2s'}}
              onMouseOver={e=>{e.currentTarget.style.borderColor='rgba(249,115,22,0.25)';e.currentTarget.style.background='rgba(255,255,255,0.06)';}}
              onMouseOut={e=>{e.currentTarget.style.borderColor='rgba(255,255,255,0.08)';e.currentTarget.style.background='rgba(255,255,255,0.04)';}}>
              <div style={{width:'44px',height:'44px',borderRadius:'12px',background:c.bg,border:`1px solid ${c.border}`,display:'flex',alignItems:'center',justifyContent:'center',marginBottom:'14px'}}>{c.ico}</div>
              <div style={{fontFamily:'Syne,sans-serif',fontSize:'15px',fontWeight:'700',marginBottom:'6px',color:'#fff'}}>{c.title}</div>
              <div style={{fontSize:'13px',color:'rgba(255,255,255,0.55)',lineHeight:'1.65'}}>{c.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── COMO FUNCIONA ── */}
      <section className="lp-section lp-how-bg" id="como">
        <div style={{textAlign:'center',maxWidth:'600px',margin:'0 auto 48px'}}>
          <div className="lp-section-label">
            <IcoArrow s={40} c="#F97316"/> Como funciona
          </div>
          <h2 className="lp-section-title">Simples. Seguro. Em 4 passos.</h2>
          <p style={{fontSize:'16px',color:'rgba(255,255,255,0.6)',lineHeight:'1.65'}}>
            Do registo à transacção concluída, o processo foi desenhado para ser fácil, rápido e sem riscos.
          </p>
        </div>
        <div className="lp-how-grid">
          {[
            { n:'1', ico:<IcoUsers s={26} c="#F97316"/>,   bg:'rgba(249,115,22,0.15)', title:'Regista e verifica',  desc:'Cria conta e confirma identidade com BI ou Passaporte. Rápido e seguro.' },
            { n:'2', ico:<IcoPackage s={26} c="#2563EB"/>, bg:'rgba(37,99,235,0.15)',  title:'Pesquisa e reserva',  desc:'Explora produtos, verifica preços, caução e regras. Faz a reserva.' },
            { n:'3', ico:<IcoLock s={26} c="#16A34A"/>,    bg:'rgba(22,163,74,0.15)',  title:'Paga com escrow',     desc:'O teu dinheiro fica protegido. O fornecedor recebe na entrega.' },
            { n:'4', ico:<IcoCheck s={26} c="#7C3AED"/>,   bg:'rgba(124,58,237,0.15)', title:'Devolve e fecha',     desc:'Devolves em bom estado, a caução é reembolsada em Kz.' },
          ].map(s=>(
            <div key={s.n} className="lp-how-step">
              <div style={{width:'64px',height:'64px',borderRadius:'18px',background:s.bg,display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 16px',position:'relative'}}>
                {s.ico}
                <span style={{position:'absolute',top:'-6px',right:'-6px',width:'20px',height:'20px',borderRadius:'50%',background:'#F97316',fontSize:'11px',fontWeight:'700',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center'}}>{s.n}</span>
              </div>
              <div className="lp-step-title">{s.title}</div>
              <div className="lp-step-desc">{s.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── SEGURANÇA / ESCROW ── */}
      <section className="lp-section" id="seguranca" style={{background:'#060E1C'}}>
        <div style={{textAlign:'center',maxWidth:'600px',margin:'0 auto 48px'}}>
          <div className="lp-section-label">
            <IcoShield s={40} c="#F97316"/> Segurança
          </div>
          <h2 className="lp-section-title">O escrow KiAluga protege toda a transacção</h2>
          <p style={{fontSize:'16px',color:'rgba(255,255,255,0.6)',lineHeight:'1.65'}}>
            Ninguém perde dinheiro. O fornecedor recebe na entrega. A caução só é libertada quando tudo corre bem.
          </p>
        </div>
        <div className="lp-security-box" style={{background:'linear-gradient(135deg,#122040,rgba(26,74,138,0.4))',border:'1px solid rgba(37,99,168,0.3)',borderRadius:'20px',padding:'36px'}}>
          {/* Fluxo visual */}
          <div>
            <div style={{display:'flex',alignItems:'center',gap:'0',marginBottom:'20px'}}>
              {[
                { ico:<IcoUsers s={22} c="#fff"/>,   name:'Cliente',    sub:'Paga aluguer + caução',  bg:'rgba(37,99,168,0.25)',  bd:'rgba(37,99,168,0.4)' },
                { arrow:true },
                { ico:<span style={{fontFamily:'Syne',fontWeight:'800',fontSize:'18px',color:'#fff'}}>K</span>, name:'KiAluga', sub:'Retém e protege', bg:'rgba(249,115,22,0.2)', bd:'rgba(249,115,22,0.4)', isK:true },
                { arrow:true },
                { ico:<IcoPackage s={22} c="#fff"/>, name:'Fornecedor', sub:'Recebe na entrega',      bg:'rgba(22,163,74,0.18)',  bd:'rgba(22,163,74,0.35)' },
              ].map((n,i)=>n.arrow
                ? <div key={i} style={{flex:'none',width:'40px',textAlign:'center',marginBottom:'24px',paddingTop:'4px'}}><IcoArrow s={18} c="#F97316"/></div>
                : <div key={i} style={{flex:1,textAlign:'center'}}>
                    <div style={{width:'56px',height:'56px',borderRadius:'14px',background:n.bg,border:`1.5px solid ${n.bd}`,display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 8px'}}>
                      {n.ico}
                    </div>
                    <div style={{fontSize:'12px',fontWeight:'600',color:'#fff'}}>{n.name}</div>
                    <div style={{fontSize:'10px',color:'rgba(255,255,255,0.4)',marginTop:'2px'}}>{n.sub}</div>
                  </div>
              )}
            </div>
            <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
              <div style={{background:'rgba(22,163,74,0.08)',border:'1px solid rgba(22,163,74,0.2)',borderRadius:'10px',padding:'10px 14px',display:'flex',alignItems:'center',gap:'10px',fontSize:'12px',color:'rgba(255,255,255,0.7)'}}>
                <div style={{width:'26px',height:'26px',borderRadius:'50%',background:'rgba(22,163,74,0.2)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  <IcoCheck s={13} c="#4ade80"/>
                </div>
                <div><strong style={{color:'#4ade80'}}>Devolução ok</strong> → caução 100% reembolsada ao cliente</div>
              </div>
              <div style={{background:'rgba(245,158,11,0.08)',border:'1px solid rgba(245,158,11,0.2)',borderRadius:'10px',padding:'10px 14px',display:'flex',alignItems:'center',gap:'10px',fontSize:'12px',color:'rgba(255,255,255,0.7)'}}>
                <div style={{width:'26px',height:'26px',borderRadius:'50%',background:'rgba(245,158,11,0.2)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  <IcoZap s={13} c="#fbbf24"/>
                </div>
                <div><strong style={{color:'#fbbf24'}}>Com problema</strong> → caução ajustada conforme regras publicadas</div>
              </div>
            </div>
          </div>
          {/* Pontos */}
          <div style={{display:'flex',flexDirection:'column',gap:'14px'}}>
            {[
              { ico:<IcoShield s={16} c="#4ade80"/>, bg:'rgba(22,163,74,0.15)',  title:'Pagamento protegido',   desc:'O dinheiro nunca vai directamente ao fornecedor antes da entrega confirmada.' },
              { ico:<IcoZap s={16} c="#F97316"/>,    bg:'rgba(249,115,22,0.12)', title:'Libertação imediata',   desc:'O fornecedor recebe o valor do aluguer em Kz no momento em que confirmas a receção.' },
              { ico:<IcoUsers s={16} c="#60a5fa"/>,  bg:'rgba(37,99,168,0.18)',  title:'Identidade verificada', desc:'Todos os utilizadores verificam identidade com BI ou Passaporte + selfie.' },
              { ico:<IcoCheck s={16} c="#a78bfa"/>,  bg:'rgba(124,58,237,0.15)', title:'Resolução de disputas', desc:'A KiAluga intervém em caso de conflito com base em provas e regras claras.' },
            ].map((p,i)=>(
              <div key={i} style={{display:'flex',gap:'12px',alignItems:'flex-start'}}>
                <div style={{width:'34px',height:'34px',borderRadius:'9px',background:p.bg,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  {p.ico}
                </div>
                <div>
                  <div style={{fontSize:'13px',fontWeight:'600',color:'#fff',marginBottom:'2px'}}>{p.title}</div>
                  <div style={{fontSize:'12px',color:'rgba(255,255,255,0.5)',lineHeight:'1.55'}}>{p.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FUNCIONALIDADES ── */}
      <section className="lp-section" id="features" style={{background:'#F8FAFD'}}>
        <div style={{textAlign:'center',maxWidth:'600px',margin:'0 auto 48px'}}>
          <div className="lp-section-label" style={{color:'#F97316'}}>
            <IcoZap s={40} c="#F97316"/> Funcionalidades
          </div>
          <h2 className="lp-section-title" style={{color:'#0A1628'}}>Tudo o que precisas numa plataforma</h2>
          <p style={{fontSize:'16px',color:'#64748B',lineHeight:'1.65'}}>
            Desenhado para a realidade angolana, com foco em confiança, simplicidade e controlo.
          </p>
        </div>
        <div className="lp-features-grid">
          {[
            { ico:<IcoPackage s={22} c="#F97316"/>, bg:'#FFF0E6', border:'rgba(249,115,22,0.15)', title:'Marketplace híbrido',      desc:'Aluga ou compra na mesma plataforma. O mesmo utilizador pode ser cliente e fornecedor.' },
            { ico:<IcoLock s={22} c="#2563EB"/>,    bg:'#EFF6FF', border:'rgba(37,99,235,0.15)',  title:'Escrow inteligente',        desc:'Sistema de pagamento protegido em Kz que garante segurança para ambas as partes.' },
            { ico:<IcoTruck s={22} c="#16A34A"/>,   bg:'#F0FDF4', border:'rgba(22,163,74,0.15)',  title:'Logística integrada',       desc:'Parceiros Yango, Heetch e UGO integrados. Entrega rápida e rastreável em Luanda.' },
            { ico:<IcoStar s={22} c="#D97706"/>,    bg:'#FFFBEB', border:'rgba(217,119,6,0.15)',  title:'Sistema de reputação',      desc:'Avaliações bidirecionais e histórico verificável criam confiança real entre desconhecidos.' },
            { ico:<IcoShield s={22} c="#7C3AED"/>,  bg:'#F5F3FF', border:'rgba(124,58,237,0.15)', title:'Verificação de identidade', desc:'BI, Passaporte e selfie. Todos os utilizadores são verificados antes de transaccionar.' },
            { ico:<IcoZap s={22} c="#0891B2"/>,     bg:'#ECFEFF', border:'rgba(8,145,178,0.15)',  title:'Gestão completa',           desc:'Painel com reservas, ganhos em Kz, anúncios e métricas. Tudo num só lugar.' },
          ].map((f,i)=>(
            <div key={i} style={{background:'#fff',border:`1px solid ${f.border}`,borderRadius:'16px',padding:'24px',transition:'all 0.2s',cursor:'default'}}
              onMouseOver={e=>{e.currentTarget.style.borderColor='rgba(249,115,22,0.4)';e.currentTarget.style.transform='translateY(-3px)';e.currentTarget.style.boxShadow='0 8px 24px rgba(249,115,22,0.1)';}}
              onMouseOut={e=>{e.currentTarget.style.borderColor=f.border;e.currentTarget.style.transform='translateY(0)';e.currentTarget.style.boxShadow='none';}}>
              <div style={{width:'48px',height:'48px',borderRadius:'12px',background:f.bg,display:'flex',alignItems:'center',justifyContent:'center',marginBottom:'16px'}}>
                {f.ico}
              </div>
              <div style={{fontFamily:'Syne,sans-serif',fontSize:'15px',fontWeight:'700',color:'#0A1628',marginBottom:'6px'}}>{f.title}</div>
              <div style={{fontSize:'13px',color:'#475569',lineHeight:'1.6'}}>{f.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── NÚMEROS ── */}
      <section className="lp-numbers-bg">
        <div className="lp-numbers-grid" style={{maxWidth:'900px',margin:'0 auto'}}>
          {[
            { ico:<IcoPercent s={28} c="rgba(255,255,255,0.7)"/>, val:'10%',       label:'Comissão por transacção',   sub:'Sobre o valor do aluguer' },
            { ico:<IcoTag s={28} c="rgba(255,255,255,0.7)"/>,     val:'18.000 Kz', label:'Ticket médio estimado',     sub:'Por transacção em Kz' },
            { ico:<IcoCheck s={28} c="rgba(255,255,255,0.7)"/>,   val:'0 Kz',      label:'Custo de registo',          sub:'Grátis para sempre' },
            { ico:<IcoClock s={28} c="rgba(255,255,255,0.7)"/>,   val:'24h',        label:'Resolução de disputas',     sub:'Tempo médio de resposta' },
          ].map((n,i)=>(
            <div key={i} style={{textAlign:'center',padding:'0 24px',borderRight:i<3?'1px solid rgba(255,255,255,0.25)':'none'}}>
              <div style={{display:'flex',justifyContent:'center',marginBottom:'10px',opacity:0.8}}>{n.ico}</div>
              <div style={{
                fontFamily:'Syne,sans-serif',
                fontSize: n.val.length > 5 ? '28px' : '40px',
                fontWeight:'800',
                color:'#fff',
                letterSpacing:'-1px',
                lineHeight:'1.1',
                marginBottom:'6px',
              }}>{n.val}</div>
              <div style={{fontSize:'13px',color:'rgba(255,255,255,0.9)',fontWeight:'600',marginBottom:'3px'}}>{n.label}</div>
              <div style={{fontSize:'11px',color:'rgba(255,255,255,0.6)'}}>{n.sub}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── TESTEMUNHOS ── */}
      <section className="lp-section" id="testemunhos" style={{background:'#060E1C'}}>
        <div style={{textAlign:'center',maxWidth:'600px',margin:'0 auto 48px'}}>
          <div className="lp-section-label">
            <IcoStar s={44} c="#F97316"/> Testemunhos
          </div>
          <h2 className="lp-section-title">O que dizem os primeiros utilizadores</h2>
        </div>
        <div className="lp-features-grid">
          {[
            {
              nome:'Ana Lima', iniciais:'AL', cor:'#1A4A8A',
              role:'Cliente · Talatona', stars:5,
              text:'Finalmente uma plataforma séria em Angola. Aluguei o vestido para o meu casamento e a caução foi devolvida no mesmo dia. Recomendo a todas as minhas amigas.',
            },
            {
              nome:'João Mendes', iniciais:'JM', cor:'#16A34A',
              role:'Fornecedor · Miramar', stars:5,
              text:'Como fornecedor, recebi o pagamento em Kz logo na entrega. Nunca mais tive o problema de não receber. Zero conflitos desde que uso a KiAluga.',
            },
            {
              nome:'Paulo Carvalho', iniciais:'PC', cor:'#D97706',
              role:'Fornecedor B2B · Maianga', stars:4,
              text:'A KiAluga ajudou-me a monetizar o stock parado nos dias sem eventos. É receita nova em Kz sem esforço extra. O sistema de escrow dá muita confiança.',
            },
          ].map((t,i)=>(
            <div key={i} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'16px',padding:'22px',transition:'all 0.2s',display:'flex',flexDirection:'column'}}
              onMouseOver={e=>e.currentTarget.style.borderColor='rgba(249,115,22,0.3)'}
              onMouseOut={e=>e.currentTarget.style.borderColor='rgba(255,255,255,0.08)'}>
              <div style={{display:'flex',gap:'2px',marginBottom:'12px'}}>
                {Array.from({length:5}).map((_,si)=>(
                  <IcoStar key={si} s={13} c={si<t.stars?'#f59e0b':'rgba(255,255,255,0.15)'}/>
                ))}
              </div>
              <p style={{fontSize:'13px',color:'rgba(255,255,255,0.7)',lineHeight:'1.7',marginBottom:'16px',flex:1}}>"{t.text}"</p>
              <div style={{display:'flex',alignItems:'center',gap:'12px',paddingTop:'14px',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
                {/* Avatar com iniciais */}
                <div style={{
                  width:'42px',height:'42px',borderRadius:'50%',
                  background:`linear-gradient(135deg,${t.cor},${t.cor}cc)`,
                  display:'flex',alignItems:'center',justifyContent:'center',
                  fontSize:'14px',fontWeight:'700',color:'#fff',flexShrink:0,
                  boxShadow:`0 0 0 2px rgba(249,115,22,0.3)`,
                }}>
                  {t.iniciais}
                </div>
                <div>
                  <div style={{fontSize:'13px',fontWeight:'600',color:'#fff'}}>{t.nome}</div>
                  <div style={{fontSize:'11px',color:'rgba(255,255,255,0.4)',marginTop:'1px'}}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{textAlign:'center',padding:'80px 40px',background:'linear-gradient(135deg,#122040,#0D1B2E,rgba(26,74,138,0.3))',position:'relative',overflow:'hidden'}}>
        <div style={{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)',width:'500px',height:'300px',background:'radial-gradient(ellipse,rgba(249,115,22,0.1),transparent 70%)',pointerEvents:'none'}}></div>
        <div style={{position:'relative',zIndex:1}}>
          <div className="lp-section-label" style={{justifyContent:'center',display:'flex'}}>
            <IcoZap s={44} c="#F97316"/> Junta-te agora
          </div>
          <h2 style={{fontFamily:'Syne,sans-serif',fontSize:'48px',fontWeight:'800',letterSpacing:'-1.5px',marginBottom:'16px',color:'#fff'}}>
            Começa a alugar.<br/><span className="lp-accent">Começa a ganhar.</span>
          </h2>
          <p style={{fontSize:'16px',color:'rgba(255,255,255,0.72)',marginBottom:'36px'}}>Regista-te gratuitamente em menos de 5 minutos.</p>
          <div style={{display:'flex',gap:'12px',justifyContent:'center'}}>
            <button className="btn btn-primary btn-lg" onClick={()=>navigate('/login')}
              style={{display:'flex',alignItems:'center',gap:'8px'}}>
              Criar conta grátis <IcoArrow s={16} c="#fff"/>
            </button>
            <button className="lp-btn-white btn btn-lg" onClick={()=>navigate('/login')}>Sou fornecedor</button>
          </div>
          <p style={{fontSize:'12px',color:'rgba(255,255,255,0.4)',marginTop:'16px'}}>Sem taxas de registo · Verificação simples · Cancela quando quiseres</p>
        </div>
      </section>

      {/* ── CONTACTO ── */}
      <section className="lp-section" id="contacto" style={{background:'#0D1B2E'}}>
        <div style={{textAlign:'center',maxWidth:'600px',margin:'0 auto 48px'}}>
          <div className="lp-section-label">
            <IcoMail s={44} c="#F97316"/> Contacto
          </div>
          <h2 className="lp-section-title">Fala connosco</h2>
          <p style={{fontSize:'16px',color:'rgba(255,255,255,0.6)',lineHeight:'1.65'}}>Tens perguntas? Queres ser parceiro? Entra em contacto.</p>
        </div>
        <div className="lp-contact-grid">
          <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
            {[
              { ico:<IcoMapPin s={18} c="#F97316"/>, title:'Localização', val:'Luanda, Angola' },
              { ico:<IcoMail s={18} c="#F97316"/>,   title:'Email',       val:'geral@kialuga.ao' },
              { ico:<IcoPhone s={18} c="#F97316"/>,  title:'WhatsApp',    val:'+244 930 854 515' },
              { ico:<IcoGlobe s={18} c="#F97316"/>,  title:'Website',     val:'www.kialuga.ao' },
            ].map((c,i)=>(
              <div key={i} style={{display:'flex',gap:'12px',alignItems:'center'}}>
                <div style={{width:'42px',height:'42px',borderRadius:'11px',background:'rgba(249,115,22,0.12)',border:'1px solid rgba(249,115,22,0.2)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  {c.ico}
                </div>
                <div>
                  <div style={{fontSize:'11px',color:'rgba(255,255,255,0.4)',textTransform:'uppercase',letterSpacing:'0.5px'}}>{c.title}</div>
                  <div style={{fontSize:'13px',fontWeight:'500',color:'#fff',marginTop:'2px'}}>{c.val}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'16px',padding:'24px'}}>
            {contactOk ? (
              <div style={{textAlign:'center',padding:'24px 0'}}>
                <div style={{width:'48px',height:'48px',borderRadius:'50%',background:'rgba(22,163,74,0.15)',border:'1px solid rgba(22,163,74,0.3)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 14px'}}>
                  <IcoCheck s={22} c="#4ade80"/>
                </div>
                <div style={{fontSize:'15px',fontWeight:'600',color:'#fff',marginBottom:'6px'}}>Mensagem enviada!</div>
                <div style={{fontSize:'13px',color:'rgba(255,255,255,0.5)'}}>Entraremos em contacto em breve.</div>
              </div>
            ) : (
              <form onSubmit={enviarContacto} style={{display:'flex',flexDirection:'column',gap:'12px'}}>
                <div>
                  <label style={{fontSize:'11px',color:'rgba(255,255,255,0.5)',display:'block',marginBottom:'5px',textTransform:'uppercase',letterSpacing:'0.5px'}}>Nome</label>
                  <input type="text" placeholder="O teu nome" required value={contactNome} onChange={e=>setContactNome(e.target.value)}
                    style={{width:'100%',padding:'9px 12px',background:'rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'8px',fontSize:'13px',color:'#fff',fontFamily:'inherit',outline:'none'}} />
                </div>
                <div>
                  <label style={{fontSize:'11px',color:'rgba(255,255,255,0.5)',display:'block',marginBottom:'5px',textTransform:'uppercase',letterSpacing:'0.5px'}}>Email</label>
                  <input type="email" placeholder="o.teu@email.com" required value={contactEmail} onChange={e=>setContactEmail(e.target.value)}
                    style={{width:'100%',padding:'9px 12px',background:'rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'8px',fontSize:'13px',color:'#fff',fontFamily:'inherit',outline:'none'}} />
                </div>
                <div>
                  <label style={{fontSize:'11px',color:'rgba(255,255,255,0.5)',display:'block',marginBottom:'5px',textTransform:'uppercase',letterSpacing:'0.5px'}}>Mensagem</label>
                  <textarea placeholder="Como podemos ajudar?" rows={4} required value={contactMsg} onChange={e=>setContactMsg(e.target.value)}
                    style={{width:'100%',padding:'9px 12px',background:'rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'8px',fontSize:'13px',color:'#fff',fontFamily:'inherit',outline:'none',resize:'vertical'}}></textarea>
                </div>
                {contactErro && <div style={{background:'rgba(220,38,38,0.1)',border:'1px solid rgba(220,38,38,0.25)',borderRadius:'8px',padding:'9px 12px',fontSize:'12px',color:'#fca5a5'}}>{contactErro}</div>}
                <button type="submit" disabled={contactLoading} className="btn btn-primary" style={{width:'100%',justifyContent:'center',padding:'11px',display:'flex',alignItems:'center',gap:'8px',opacity:contactLoading?0.7:1}}>
                  {contactLoading ? 'A enviar...' : <><span>Enviar mensagem</span><IcoArrow s={14} c="#fff"/></>}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="lp-footer">
        <div className="lp-footer-accent" />
        <div className="lp-footer-grid">
          {/* Brand column */}
          <div>
            <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'14px'}}>
              <div className="lp-logo-k" style={{width:'34px',height:'34px',fontSize:'18px'}}>K</div>
              <span style={{fontFamily:'Syne,sans-serif',fontWeight:'800',fontSize:'20px',color:'#fff'}}>KiAluga</span>
            </div>
            <p className="lp-footer-tagline">
              A principal plataforma angolana de aluguer com pagamento protegido. Ativos em uso. Valor em circulação.
            </p>
            <div className="lp-footer-contact">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <a href="mailto:kialuga@gmail.com">kialuga@gmail.com</a>
            </div>
            <div className="lp-footer-contact">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.2 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.6a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              <a href="tel:+244923000000">+244 923 000 000</a>
            </div>
            <div className="lp-footer-socials">
              {/* WhatsApp */}
              <div className="lp-footer-social-btn" title="WhatsApp">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>
              </div>
              {/* Instagram */}
              <div className="lp-footer-social-btn" title="Instagram">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              </div>
              {/* LinkedIn */}
              <div className="lp-footer-social-btn" title="LinkedIn">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
              </div>
              {/* Facebook */}
              <div className="lp-footer-social-btn" title="Facebook">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
              </div>
            </div>
          </div>

          {/* Nav columns */}
          {[
            { title:'Plataforma', links:[{l:'Como funciona',id:'como'},{l:'Explorar produtos',path:'/login'},{l:'Publicar anúncio',path:'/login'},{l:'Preços e comissões',id:'features'}] },
            { title:'Empresa',    links:[{l:'Sobre a KiAluga',id:'hero'},{l:'FAQ',path:'/documentos'},{l:'Parcerias',id:'contacto'},{l:'Contacto',id:'contacto'}] },
            { title:'Suporte',    links:[{l:'Centro de ajuda',id:'contacto'},{l:'Guia do Cliente',path:'/documentos'},{l:'Guia do Fornecedor',path:'/documentos'},{l:'Resolver Disputas',path:'/documentos'}] },
          ].map(col=>(
            <div key={col.title}>
              <div className="lp-footer-col-title">{col.title}</div>
              {col.links.map(lk=>(
                <div key={lk.l} className="lp-footer-link" onClick={()=>lk.path?navigate(lk.path):scrollTo(lk.id)}>
                  {lk.l}
                </div>
              ))}
            </div>
          ))}

          {/* Legal column */}
          <div>
            <div className="lp-footer-col-title">Legal</div>
            {[
              {l:'Termos e Condições'},
              {l:'Política de Privacidade'},
              {l:'Política de Cookies'},
              {l:'Política de Escrow'},
              {l:'Política de Caução'},
              {l:'Cancelamento & Reembolso'},
            ].map(lk=>(
              <div key={lk.l} className="lp-footer-link" onClick={()=>navigate('/documentos')}>
                {lk.l}
              </div>
            ))}
          </div>
        </div>

        <hr className="lp-footer-divider" />

        <div className="lp-footer-bottom">
          <span>© 2026 KiAluga · ZungaLab, Lda.</span>
          <div className="lp-footer-bottom-center">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
            <span>Feito em Angola · Luanda</span>
          </div>
          <div className="lp-footer-badges">
            <span className="lp-footer-badge"><IcoLock s={11} c="#F97316"/>Escrow protegido</span>
            <span className="lp-footer-badge"><IcoShield s={11} c="#F97316"/>KYC verificado</span>
            <span className="lp-footer-badge"><IcoCheck s={11} c="#F97316"/>SSL seguro</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
